<template>
    <div class="modal card simple-dialog" ref="meuDialog" :style="dialogStyle">
        <div class="modal-content" :class="{ [`${styleContent}`]: styleContent, 'pa-1': !styleContent }">
            <h4 class="ma-0 pa-1" v-if="!!title">{{title}}</h4>
            <slot><p>{{detail}}</p></slot>
        </div>
        <div class="divider col s12 pa-0" v-if="closeButton"></div>
        <div class="row ma-0" v-if="closeButton">
            <div class="col s12 pa-0 center">
                <a
                    href="#!"
                    @click.prevent="fechar"
                    class="modal-action waves-effect waves-green btn-flat col s12 ma-0 pa-0">
                    {{closeLabel}}
                </a>
            </div>
            <div class="col s6 pa-0"></div>
        </div>
    </div>
</template>
<script>
export default {
    name:'simple-dialog',
    props: {
        title:{type:String, required:null},
        detail:{type:String, required:false},
        width:{type:[String, Number], required:false, default: null},
        height:{type:[String, Number], required:false, default: null},
        show:{type:Boolean, required:true},
        closeButton:{type:Boolean, required:false, default: true},
        dismissible:{type:Boolean, required:false, default:true},
        closeLabel:{type:String, required:false, default:'Fechar'},
        styleContent:{type:String, default: null},
    },
    computed: {
        dialogStyle() {
            const style = {};

            if (this.width) {
                style.width = this.normalizarDimensao(this.width);
            }

            if (this.height) {
                style.height = this.normalizarDimensao(this.height);
            }

            return style;
        }
    },
    watch:{
        show:function(newValue) {
            if (newValue) { 
                $(this.$refs.meuDialog).modal('open');
            } else {
                $(this.$refs.meuDialog).modal('close');
            }
        }
    },
    methods:{
        normalizarDimensao(valor) {
            return typeof valor === 'number' ? `${valor}px` : valor;
        },
        fechar() {
            this.$emit('beforeClose');
            this.$emit('onClose');
        }
    },
    mounted(){
        $(this.$refs.meuDialog).modal({
            dismissible: this.dismissible,
            complete: ()=>{
                this.$emit('onClose');
            }
        });
    }
}

</script>


<style lang="scss" scoped>

	@media only screen and (max-width: 600px) {
		.simple-dialog {
            width: 95% !important;
		}
	}

</style>



// WEBPACK FOOTER //
// SimpleDialog.vue?6bf68d8a